import React from 'react';
import ReactDOM from 'react-dom';
import './Loader.scss';
import LoaderGif from '../../assets/images/loader.gif';

const Loader: React.FC = () => {
  return ReactDOM.createPortal(
    <div className="loader-container">
      <img src={LoaderGif} alt="Loading..." className="loader-image" />
      {/* Optional text */}
      {/* <span className="timer-loader">Loading…</span> */}
    </div>,
    document.body
  );
};

export default Loader;